import SEOHead from "@/components/feature/SEOHead";
import Breadcrumb from "@/components/feature/Breadcrumb";
import { faqs } from "./components/FAQ";
import Navbar from "../../components/feature/Navbar";
import DiagnosticVideo from "../../components/feature/DiagnosticVideo";
import Footer from "../../components/feature/Footer";
import FloatingButton from "../../components/feature/FloatingButton";
import Avis from "../../components/feature/Avis";
import Hero from "./components/Hero";
import Reassurances from "./components/Reassurances";
import PanneElectrique from "./components/PanneElectrique";
import Diagnostic from "./components/Diagnostic";
import MarquesMotorisation from "./components/MarquesMotorisation";
import ReparerPlutot from "./components/ReparerPlutot";
import CTAAppel from "./components/CTAAppel";
import FAQ from "./components/FAQ";
import Galerie from "./components/Galerie";
import Maillage from "./components/Maillage";
import Formulaire from "./components/Formulaire";

export default function ReparationVoletElectrique() {
  return (
    <div className="min-h-screen bg-white">
      <SEOHead
        title="Réparation Volet Électrique Strasbourg | Toutes Marques"
        description="Réparation de volet roulant électrique à Strasbourg et dans le Bas-Rhin. Moteur, télécommande, diagnose rapide, devis gratuit. 03 74 47 32 40."
        path="/reparation-volet-electrique"
        type="service"
        serviceType="Réparation de volet roulant électrique"
        faqs={faqs}
        breadcrumbs={[{ label: "Accueil", href: "/" }, { label: "Réparation électrique" }]}
      />
      <Navbar />
      <Breadcrumb items={[{ label: "Accueil", href: "/" }, { label: "Réparation électrique" }]} />
      <main>
        <Hero />
        <DiagnosticVideo />
        <Reassurances />
        <PanneElectrique />
        <Diagnostic />
        <MarquesMotorisation />
        <ReparerPlutot />
        <CTAAppel />
        <FAQ />
        <Galerie />
        <Maillage />
        <Formulaire />
        <Avis />
      </main>
      <Footer />
      <FloatingButton />
    </div>
  );
}